module.exports = __webpack_public_path__ + "img/guru_xmas.jpg";